export default function loginBlock(){
    const open = document.querySelector(".login");
    const block = document.getElementById("menu__block");
    const close = document.getElementById("close-button");

    open.addEventListener("click", () => {
        block.style.display = "flex";
    });

    close.addEventListener("click", () => {
        block.style.display = "none";
    });
}
